/* Ilinca & Elena - product page: dispatch date and discount badge per variant */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function nextBusinessDay() {
    var d = new Date();
    d.setDate(d.getDate() + 1);
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    return d;
  }
  var shipDate = nextBusinessDay();
  document.querySelectorAll('[data-rl-ship-date]').forEach(function (el) {
    el.textContent = pad(shipDate.getDate()) + '.' + pad(shipDate.getMonth() + 1) + '.';
  });

  var dataEl = document.querySelector('[data-rl-variants]');
  if (!dataEl) return;
  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  function currentId() {
    var input = document.querySelector('.product-section form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return input.value;
    var m = window.location.search.match(/variant=(\d+)/);
    return m ? m[1] : null;
  }

  function update() {
    var id = currentId();
    var v = null;
    for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(id)) { v = variants[i]; break; } }
    if (!v) return;
    var badge = document.querySelector('[data-rl-save-badge]');
    var pct = document.querySelector('[data-rl-save-pct]');
    if (badge && pct) {
      var p = v.compare > v.price ? Math.floor((v.compare - v.price) * 100 / v.compare / 5) * 5 : 0;
      pct.textContent = p;
      badge.hidden = p < 5;
    }
  }

  document.addEventListener('change', function () { setTimeout(update, 60); });
  var price = document.querySelector('[data-product-price]');
  if (price) new MutationObserver(update).observe(price, { childList: true, subtree: true, characterData: true });
})();
